<template>
  <div class="relative h-96 ml-5 mr-5 mb-5">
    <div v-if="isLoading" class="h-full">
      <div class="flex items-end space-x-2 h-full">
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-3/4 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-52 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-36 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
      </div>
    </div>
    <canvas id="participationChartReports" ref="participationChart" class="cursor-pointer"></canvas>
  </div>
</template>
<script>
  import Vue from 'vue';
  import Chart from 'chart.js';
  import store from 'store';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import getOnlineRoundtableEngagement from 'services/courses/getOnlineRoundtableEngagement';
  import getMyOnlineRoundtableEngagement from 'services/courses/getMyOnlineRoundtableEngagement';
  import { EventBus } from '../../../../../utils/event-bus';

  export default Vue.extend({
    data() {
      return {
        statisticsChart: undefined,
        isLoading: false,
        avgComments: [],
      };
    },
    watch: {
      '$route': function () {
        /* Restart Chart When Route Changes */
        this.statisticsChart.destroy();
        this.getChartData();
      },
      SidebarState: function(){
        window.addEventListener('beforeprint', () => {
          this.statisticsChart.resize(600, 600);
        });
      }
    },
    computed: {
      ...mapGetters(['getProfile', 'hasTeacherPermissionsInCourse']),
      SidebarState: function() {
        return store.state.globalStateSidebar.isOpen;
      },
    },
    methods: {
      handleSum: async function(submitted, comments, replies) {
        const total = parseInt(submitted) + parseInt(comments) + parseInt(replies);
        return total;
      },
      destroyTooltip() {
        this.statisticsChart.options.plugins.tooltip.enabled = false;
        this.statisticsChart.update();
      },
      setChart: function (studentRoundTables) {
        studentRoundTables.map((rt) => {
          rt.submission_started === 0 ? rt.submission_started = 1 : rt.submission_started = 1;
        });
        const roundtablesStudent = studentRoundTables.sort((a, b) => {
          return new Date(a.roundtable_at) - new Date(b.roundtable_at);
        });
        this.statisticsChart = new Chart(this.$refs.participationChart, {
          type: 'bar',
          data: {
            labels: roundtablesStudent.map((rt) => rt.roundtable_id),
            datasets: [
              {
                label: 'Class Comments Average',
                data: roundtablesStudent.map((rt) => rt.average_contributions),
                borderColor: '#FF9419',
                type: "line",
                borderWidth: 3,
                fill: false,
              },
              {
                label: 'Responded?',
                data: roundtablesStudent.map((rt) => rt.submission_started),
                backgroundColor: roundtablesStudent.map((rt) => rt.submitted === 1 ? 'rgba(114, 204, 215, 1)' : 'rgba(244, 244, 245)'),
                maxBarThickness: 64,
              },
              {
                label: 'Comments Made',
                data: roundtablesStudent.map((rt) => rt.comments_number),
                backgroundColor: 'rgba(39, 50, 72, 1)',
                maxBarThickness: 64,
              },
              {
                label: 'Replies Made',
                data: roundtablesStudent.map((rt) => rt.replies_number),
                backgroundColor: 'rgba(235, 45, 124, 1)',
                maxBarThickness: 64,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, activeElements) => {
              
              if (activeElements.length > 0) {
                const tooltipEl = document.getElementById('chartjs-tooltip');
                const children = tooltipEl.children[0].children;
                if (tooltipEl)  {
                  tooltipEl.remove();
                }
                if (this.getProfile.is_paid === false) {
                  return;
                }
                EventBus.$emit('handleChangeReportsTab', 'course.student-reports.discussion', children[0].id);
              }
            },
            layout: { padding: { right: 1 }},
            scales: {
              xAxes: [{ stacked: true, ticks: { display: false } }],
              yAxes: [{ stacked: true, beginAtZero: true, grace: 15, ticks: { userCallback: (label) => Math.floor(label) === label ? label : '', stepSize: 2 } }],
            },
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
              labels: { boxWidth: 12, boxHeight: 10 },
            },
            tooltips: {
              enabled: false,
              custom: function (tooltipModel) {
                let tooltip = document.getElementById('chartjs-tooltip');
                if (!tooltip) {
                  tooltip = document.createElement('div');
                  tooltip.id = 'chartjs-tooltip';
                  tooltip.innerHTML = '<div class="bg-white py-2 rounded shadow-lg"></div>';
                  document.body.appendChild(tooltip);
                }
                if (tooltipModel.opacity === 0) {
                  tooltip.style.opacity = '0';
                  if (tooltip) {
                    tooltip.parentNode.removeChild(tooltip);
                  }
                  return;
                }
                tooltip.classList.remove('below', 'no-transform');
                if (tooltipModel.body) {
                  let title = tooltipModel.title;
                  const roundTableToShow = studentRoundTables.find((rt) => {
                    return rt.roundtable_id === title[0];
                  });
                  const innerHtml = `
                  <div id="${roundTableToShow.roundtable_id}">
                    <div class="flex items-center space-x-2 px-4 py-1">
                      <div class="h-5 w-5 bg-blue rounded-full flex items-center justify-center">
                        <img src="/static/roundtable_icons/written_icon.svg" class="w-2.5 h-2.5"/>
                      </div>
                      <h6 class="font-poppins font-semibold text-blueGray-800">${roundTableToShow.roundtable.charAt(0).toUpperCase() + roundTableToShow.roundtable.slice(1)}</h6>
                    </div>
                    <div class="border-b border-solid border-gray-200 mt-1.5"></div>
                    <div class="px-4 py-2 w-full font-poppins text-blueGray-800 font-light">
                      <ul>
                        <li class="flex justify-between items-center mb-2">
                          <div class="flex items-center mr-4">
                            <div class="w-3 h-3 bg-primary mr-2"></div>
                            <span>Responded?</span>
                          </div>
                          <span>${ roundTableToShow.submitted === 0 ? 'No' : 'Yes'}</span>
                        </li>
                        <li class="flex justify-between items-center mb-2">
                          <div class="flex items-center mr-4">
                            <div class="w-3 h-3 bg-blueGray-800 mr-2"></div>
                            <span>Comments Made</span>
                          </div>
                          <span>${roundTableToShow.comments_number}</span>
                        </li>
                        <li class="flex justify-between items-center">
                          <div class="flex items-center mr-4">
                            <div class="w-3 h-3 bg-pinky mr-2"></div>
                            <span>Replies Made</span>
                          </div>
                          <span>${roundTableToShow.replies_number}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="border-b border-solid border-gray-200 mt-1.5"></div>
                    <div class="px-4 py-2 w-full font-poppins text-blueGray-800 font-light">
                      <ul>
                        <li class="flex justify-between items-center mb-2">
                          <div class="flex items-center mr-4">
                            <div class="w-3 h-3 bg-gray-300 mr-2"></div>
                            <span>Total Contributions</span>
                          </div>
                          <span>${roundTableToShow.submitted + roundTableToShow.comments_number + roundTableToShow.replies_number}</span>
                        </li>
                        <li class="flex justify-between items-center mb-2">
                          <div class="flex items-center mr-4">
                            <div class="w-3 h-3 bg-orange mr-2"></div>
                            <span>Class Contributions Average</span>
                          </div>
                          <span>${roundTableToShow.average_contributions.toFixed(2)}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                `;
                  tooltip.querySelector('div').innerHTML = innerHtml;
                }
                let position = this._chart.canvas.getBoundingClientRect();
                tooltip.style.opacity = 1;
                tooltip.style.position = 'absolute';
                tooltip.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                tooltip.style.top = position.top + 20 + window.pageYOffset  + tooltipModel.caretY + 'px';
                tooltip.style.fontSize = tooltipModel.bodyFontSize + 'px';
                tooltip.style.fontStyle = tooltipModel._bodyFontStyle;
              },
            },
          },
          plugins: [{
            afterDraw: function(chart) {
              // Customize Year for Empty Data Or Change to HTML
              if (chart.data.datasets[0].data.length === 0) {
                let ctx = chart.chart.ctx;
                let width = chart.chart.width;
                let height = chart.chart.height;
                chart.clear();
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText('No data to display', width / 2, height / 2);
                ctx.restore();
              }
            }
          }],
        });
      },
      getChartData: async function(){
        this.isLoading = true;
        const { courseID, studentID } = this.$route.params;
        const { startDate, endDate } = this.$route.query;
        const dateStart =  startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
        const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';
        if (this.getProfile.id === studentID) {
          const result = await getMyOnlineRoundtableEngagement(courseID, dateStart, dateEnd);
          this.isLoading = false;
          return this.setChart(result);
        }
        const result = await getOnlineRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
        this.isLoading = false;
        return this.setChart(result);
      }
    },
    mounted: async function() {

      if (this.getProfile.is_paid === false) {
        this.isLoading = true;
        const result = [
          {
            roundtable: 'Sample Written RoundTable',
            roundtable_id: '0',
            roundtable_at: '2025-04-21T14:59:58.719Z',
            submission_started: 1,
            comments_number: 0,
            average_comments_in_class: 0,
            replies_number: 0,
            average_replies_in_class: 0,
            average_contributions: 0.75,
            totalSubmissionsStarted: 6,
            submitted: 1,
          },
          {
            roundtable: 'The Escalating US-China Trade War: Tariff Clash Intensifies Global Tensions',
            roundtable_id: '1',
            roundtable_at: '2025-04-21T14:59:58.719Z',
            submission_started: 1,
            comments_number: 4,
            average_comments_in_class: 0.56,
            replies_number: 0.74,
            average_replies_in_class: 1.1,
            average_contributions: 1.3,
            totalSubmissionsStarted: 6,
            submitted: 1,
          },
          {
            roundtable: 'Trump Clarifies Trade Stance: No Tariff Exemptions for Electronics Imports',
            roundtable_id: '2',
            roundtable_at: '2025-04-21T14:59:58.719Z',
            submission_started: 1,
            comments_number: 2,
            average_comments_in_class: 1.6,
            replies_number: 0.6,
            average_replies_in_class: 0.8,
            average_contributions: 0.91,
            totalSubmissionsStarted: 6,
            submitted: 1,
          },
        ];
        this.setChart(result);
        this.isLoading = false;
        return;
      }

      this.getChartData();

    },
  });
</script>



// WEBPACK FOOTER //
// ParticipationChart.vue?62524b36